export default __webpack_public_path__ + "static/media/Feather.b2469c88.ttf";